import React from 'react';
import ScrollingText from './Decor/Scrolling';

const Header = () => {
  return <div>
    <ScrollingText/>
  </div>;
};

export default Header;
